export const FETCH_NOTIFICATIONS = "FETCH_NOTIFICATIONS";
export const POST_NOTIFICATION = "POST_NOTIFICATION";
export const SUBSCRIBE_TO_CREATE_NOTIFICATION =
  "SUBSCRIBE_TO_CREATE_NOTIFICATION";
export const NOTIFICATION_CREATED = "NOTIFICATION_CREATED";
